
import React from "react";
import { useUserRoles } from "@/hooks/useUserRoles";
import { TeamLogoManager } from "./TeamLogoManager";
import { AdminBrandingSettings } from "./AdminBrandingSettings";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Sparkles, Paintbrush, Lock } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export const AppearanceSettings = () => {
  const { t } = useLanguage();
  const { isAdmin, isContributor } = useUserRoles();

  // Show friendly message to contributors
  if (isAdmin && isContributor) {
    return (
      <div className="space-y-8">
        <Card className="border-2 border-primary/20 bg-gradient-to-br from-purple-50/50 to-blue-50/50 dark:from-purple-950/20 dark:to-blue-950/20">
          <CardHeader>
            <div className="flex items-center gap-2">
              <Paintbrush className="h-5 w-5 text-purple-500" />
              <CardTitle>{t('appearance')}</CardTitle>
            </div>
            <CardDescription>
              {t('customizeInterface')}
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Alert className="border-purple-200 bg-purple-50/50 dark:border-purple-800 dark:bg-purple-950/30">
              <div className="flex items-start gap-3">
                <div className="flex gap-2 mt-0.5">
                  <Sparkles className="h-5 w-5 text-purple-500 animate-pulse" />
                  <Lock className="h-5 w-5 text-blue-500" />
                </div>
                <AlertDescription className="text-sm">
                  <p className="font-medium text-purple-900 dark:text-purple-100 mb-2">
                    🎨 {t('brandingAppearanceCustomization')}
                  </p>
                  <p className="text-purple-800 dark:text-purple-200">
                    {t('contributorAppearanceMessage')}
                  </p>
                  <p className="text-purple-700 dark:text-purple-300 mt-2 text-xs">
                    ✨ {t('inheritThemeMessage')}
                  </p>
                </AlertDescription>
              </div>
            </Alert>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {isAdmin && !isContributor && <AdminBrandingSettings />}
      
      {isAdmin && !isContributor && <TeamLogoManager />}
    </div>
  );
};
